module.exports = __webpack_public_path__ + "static/media/articleTwo.07782597.webp";